import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/store/AuthContext';
import { tokenStorage } from '@/lib/api';
import { LoadingSpinner } from '@/components/atoms/LoadingSpinner';
import { getRequiredPermission } from './routePermissions';

export function ProtectedRoute() {
  const { isAuthenticated, isLoading, loadCurrentUser, hasPermission, permissions } = useAuth();
  const hasToken = Boolean(tokenStorage.getAccess());
  const location = useLocation();

  useEffect(() => {
    if (hasToken && !isAuthenticated && !isLoading) {
      loadCurrentUser();
    }
  }, [hasToken, isAuthenticated, isLoading, loadCurrentUser]);

  if (hasToken && isLoading) return <LoadingSpinner fullPage />;
  if (!hasToken && !isAuthenticated) return <Navigate to="/login" replace />;

  // Wait until permissions are loaded before checking route access
  if (isAuthenticated && permissions.length > 0) {
    const requiredPerm = getRequiredPermission(location.pathname);
    if (requiredPerm && !hasPermission(requiredPerm)) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return <Outlet />;
}

